import React from 'react';
import axios from 'axios';
import { Link, withRouter } from 'react-router-dom';
import { RenderFileUpload } from '../../component/formInput';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { objectToFormData } from 'object-to-formdata';
import moment from 'moment';
import BlockUI from '../../component/BlockUI';

var _ = require('lodash');

function DomainTrackingRows(data) {
  return _.map(data,(item, key) => (
    <tr className={item.diff == 9999 && "alpha-danger"} key={key}>
      <td>
        {item.domain}
      </td>
      <td>
        {moment(item.tadu_expired).format("DD-MM-YYYY HH:mm:ss")}
      </td>
      <td>
        {item.external_expired ? moment(item.external_expired).format("DD-MM-YYYY HH:mm:ss") : ""}
      </td>
      <td>
        {item.diff != 9999 ? item.diff : ""}
      </td>
    </tr>
  ))
}

class DomainTracking extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      table_data: [],
      supplier_tracking: null,
      isLoading: true
    }
  }

  componentDidMount() {
    const self = this;
    axios({
      method: 'get',
      url: window.api_url + '/admin/api/domain/missing',
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        self.setState({
          ...self.state,
          table_data: response.data,
          isLoading: false
        })
      }
    });
  }

  render() {
    const {table_data, isLoading, supplier_tracking} = this.state;
    const {handleSubmit} = this.props;
    return(
      <React.Fragment>
        {isLoading && <BlockUI />}
        <div className="page-header">
          <div className="page-header-content header-elements-md-inline">
            <div className="page-title d-flex">
              <h4>
                <i className="icon-paragraph-justify2 mr-2"></i>
                <span className="text-semibold">Rà Soát Tên Miền</span>
              </h4>
            </div>
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="table-responsive">
                <table className="table table-togglable table-hover default footable-loaded footable">
                  <thead>
                    <tr>
                      <th>
                        Tên Miền
                      </th>
                      <th>
                        Ngày hết hạn từ TADU
                      </th>
                      <th>
                        Ngày hết hạn từ NCC
                      </th>
                      <th>
                        Ngày Chênh Lệch
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {table_data && DomainTrackingRows(table_data)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapState = state => ({

});

const mapDispatch = (dispatch) => ({

});

const DomainTrackingWrapper = reduxForm({
  form: 'DomainTracking',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(DomainTracking);

export default connect(mapState, mapDispatch)(withRouter(DomainTrackingWrapper));